import { connect } from 'react-redux';
import React, { useCallback } from 'react';
import { Button, Grid, Divider } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../store';
import UndoActionButton from './controls/UndoActionButton';
import RedoActionButton from './controls/RedoActionButton';
import AspectRatioToggleButtonGroup from './controls/AspectRatioToggleButtonGroup';
import CreateNewVideoButton from './controls/CreateNewVideoButton';
import SaveVideoDropdown from './controls/SaveVideoDropdown';
import { useNavigate } from 'react-router';

const styles = (theme) => ({
    buttonsDivider: {
        height: 25,
        marginLeft: 3,
        marginRight: 3
    },
    exportVideoButton: {
        marginLeft: 5
    },
});

const TopBarActions = ({ classes, openExportDialog, backgroundVideosLoading, videoExports, isExportsDataLoading, videoSettingsLoading, videoSettingsId, savingInProgress, saveVideoProject }) => {
    const navigate = useNavigate();

    const disableActions = savingInProgress || videoSettingsLoading || backgroundVideosLoading;

    const save = useCallback((showSnack, onSaveComplete) => {
        if (savingInProgress) 
            return;

        saveVideoProject((videoId) => {
            if (typeof onSaveComplete === 'function') {
                onSaveComplete(videoId);
            }
        }, showSnack, navigate);
    }, [savingInProgress, saveVideoProject]);

    const handleNavigate = useCallback((path) => {
        navigate(path);
    }, []);

    const onSeeExportsClick = useCallback(() => {
        handleNavigate(`/exports/${videoSettingsId}`);
    }, [handleNavigate, videoSettingsId]);

    return (
        <Grid
            container
            spacing={1}
            alignItems='center'
            justifyContent='center'
            style={{ height: '100%', margin: 0 }}
        >
            <Grid>
                {/* Render a button for UNDO operation */}
                <UndoActionButton />
            </Grid>
            <Grid>
                {/* Render a button for REDO operation */}
                <RedoActionButton />
            </Grid>
            <Grid>
                <Divider
                    className={classes.buttonsDivider}
                    orientation='vertical'
                />
            </Grid>
            <Grid>
                <AspectRatioToggleButtonGroup />
            </Grid>
            <Grid>
                <Divider
                    className={classes.buttonsDivider}
                    orientation='vertical'
                />
            </Grid>
            <Grid>
                <CreateNewVideoButton navigate={handleNavigate} />
            </Grid>
            <Grid>
                <SaveVideoDropdown save={save} />
            </Grid>
            <Grid>
                <Button
                    className={classes.exportVideoButton}
                    variant='outlined'
                    onClick={() => openExportDialog(navigate)}
                    color='primary'
                    disabled={disableActions}
                >
                    Export Video
                </Button>
            </Grid>
            {(videoExports ? videoExports : []).length > 0 &&
                <Grid>
                    <Button
                        onClick={onSeeExportsClick}
                        disabled={!videoSettingsId || videoSettingsLoading || isExportsDataLoading}
                    >
                        See Exports
                    </Button>
                </Grid>
            }
        </Grid>
    );
}

const mapStateToProps = (state) => {
    const { videoSettingsLoading, backgroundVideosLoading } = state.create;
    const { videoExports, isExportsDataLoading } = state.exports;
    const { id: videoSettingsId } = state.createPreview.present.videoSettings;
    const { savingInProgress } = state.create.videoSavingState;

    return {
        videoExports,
        backgroundVideosLoading,
        isExportsDataLoading,
        videoSettingsLoading,
        videoSettingsId,
        savingInProgress
    }
}

const mapDispatchToProps = (dispatch) => {
    const openExportDialog = (navigate) => dispatch(createActions.openExportDialog(navigate));
    const saveVideoProject = (onSaveComplete, showSnack, navigate) => dispatch(createActions.saveVideoProject(onSaveComplete, showSnack, navigate));

    return {
        openExportDialog,
        saveVideoProject
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TopBarActions, styles));